import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, Observable } from 'rxjs';
import { Address } from '../models/address';
import { Parcel, Stop, Stops } from '../models/live-route';
import { LiveRouteStatus } from '../models/live-route-status';
import { ApiProvider } from '../providers/api.provider';
import { SectorService } from './sector.service';
import { GeoTabUser } from '../models/geoab-user';
import { SpinnerService } from './SpinnerService';

@Injectable({
  providedIn: 'root'
})
export class OnHoldService {
  public currentOnholdsSubject: BehaviorSubject<Stops>;
  public currentOnhold: Observable<Stops>;
  public dataSourceOnhold: MatTableDataSource<Stop>;
  public minLiveRouteStatus: number = 0;
  public RouteID: number = 0;
  public RouteDate: Date = new Date();
  public StopCount: number;
  public latitude: number = 45.500922;
  public longitude: number = -73.443143;

  private currentParcel: Parcel;
  private currentOnholdStop: Stop;
  public CurrentOnholdDataRoot: Stops = new Stops();
  public CurrentOnholdDataStops: Stops[] = [];


  public geotabUsers = new Array<GeoTabUser>();
  public geotabUsersDisplay = new Array<GeoTabUser>();

  constructor(
    public apiProvider: ApiProvider,
    private datePipe: DatePipe,
    public SpinService: SpinnerService,
    public _sectorService: SectorService
  ) {
    this.currentOnholdsSubject = new BehaviorSubject<Stops>(null);
    // this.currentStopsSubject.getValue().StopsList[0].ParcelCompress[0].No_Stop
  }

  public get currentStopsValue(): Stops {
    return this.currentOnholdsSubject.value;
  }

  public get selectedStops(): Stop[] {
    if (this.dataSourceOnhold && this.dataSourceOnhold.data) {
      return this.dataSourceOnhold.data.filter((x) => x.IsSelected === true);
    } else {
      const Stoplist: Stop[] = [];
      return Stoplist;
    }
  }

  public get selectedStopsAllowedException(): Stop[] {
    return this.selectedStops.filter((x) =>
      x.ParcelCompress.filter(
        (y) => y.Live_Route_Status === this.minLiveRouteStatus
      )
    );
  }
  /*
  public get visibleStops(): Stop[] {
    return this.currentStopsValue.StopsList.filter(x => (this.authenticationService.currentUserValue.FilterCompleted == 0 ||
      (this.authenticationService.currentUserValue.FilterCompleted == 1 && x.TotalScanned == x.ParcelCompress.length) ||
      (this.authenticationService.currentUserValue.FilterCompleted == 2 && x.TotalScanned != x.ParcelCompress.length) ));
  }
    */

  public GetStop(Consol_ID: number): Stop {
    return this.currentStopsValue.StopsList.find(
      (x) => x.Consol_ID === Consol_ID
    );
  }

  public GetStopFromParcel(ParcelID: number): Stop {
    return this.currentStopsValue.StopsList.find(
      (x) => x.ParcelCompress.find((y) => y.Parcel_ID === ParcelID).IsSelected
    );
  }

  public GetParcel(ParcelID: number): Parcel {
    this.currentOnholdStop = this.GetStopFromParcel(ParcelID);
    if (this.currentOnholdStop == null) return null;
    this.currentParcel = this.currentOnholdStop.ParcelCompress.find(
      (x) => x.Parcel_ID === ParcelID
    );
    return this.currentParcel;
  }

  public GetStopCountPerStatus(Live_Route_Status: number): number {
    return this.currentStopsValue.StopsList.filter((x) =>
      x.ParcelCompress.find((y) => y.Live_Route_Status >= Live_Route_Status)
    ).length;
  }

  public ChangeParcelStatus(
    ParcelID: number,
    LiveRouteStatus: number
  ): boolean {
    this.currentParcel = this.GetParcel(ParcelID);
    if (this.currentParcel.Live_Route_Status < LiveRouteStatus) {
      this.currentParcel.Live_Route_Status = LiveRouteStatus;
      this.currentOnholdStop.TotalScanned++;
      this.currentStopsValue.TotalScannedCount++;
      return true;
    } else return false;
  }

  async initialiseOnholdRoute() {
    this.GetDataFromDataBase();
  }

  private SelectedDateEqualsToToday() {
    return (
      this.datePipe.transform(this.RouteDate, 'yyyy-MM-dd') ===
      this.datePipe.transform(new Date(), 'yyyy-MM-dd')
    );
  }

  private GetDataFromDataBase() {
    if(this._sectorService.SectorID == null)
      return;
    this.apiProvider
      .getStopsParcels(
        this._sectorService.SectorID,
        this.minLiveRouteStatus,
        LiveRouteStatus.Postponed,
        this.datePipe.transform(this.RouteDate, 'yyyy-MM-dd')
      )
      .subscribe(
        (stops: Stops) => {
          this.CurrentOnholdDataRoot = stops;
          this.currentOnholdsSubject = new BehaviorSubject<Stops>(
            this.CurrentOnholdDataRoot
          );
          this.currentOnhold = this.currentOnholdsSubject.asObservable();
          this.dataSourceOnhold = new MatTableDataSource<Stop>(
            this.CurrentOnholdDataRoot.StopsList
          );
          this.StopCount = this.CurrentOnholdDataRoot.StopsList.length;
          if (this.StopCount > 0) {
            this.latitude = stops.StopsList[0].Address.Latitude;
            this.longitude = stops.StopsList[0].Address.Longitude;
          }
        },
        (err: HttpErrorResponse) => {
          this.currentOnholdsSubject.next(null);
        }
      );

  }

  public getPrintRoutePDF(routeId: number, date: Date): Observable<Blob> {
    return this.apiProvider.getPrintRoutePDF(routeId, date);
  }

}
